import { render, staticRenderFns } from "./FailureView.vue?vue&type=template&id=2b7c41a3&scoped=true&"
import script from "./FailureView.vue?vue&type=script&lang=js&"
export * from "./FailureView.vue?vue&type=script&lang=js&"
import style0 from "./FailureView.vue?vue&type=style&index=0&id=2b7c41a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7c41a3",
  null
  
)

export default component.exports